import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import EquipmentDatabase from '../../components/admin/EquipmentDatabase';

const EquipmentLibraryPage = () => {
  return (
    <AdminLayout title="Equipment Library">
      <EquipmentDatabase />
    </AdminLayout>
  );
};

export default EquipmentLibraryPage;
